module.exports = __webpack_public_path__ + "img/coin.72a1657c.svg";